import { Component, OnInit } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttributeDeletionConfirmationComponent } from 'src/app/components/dialog/attributes/attribute-deletion-confirmation/attribute-deletion-confirmation.component';
import { AttributesActionsComponent } from 'src/app/components/dialog/attributes/attributes-actions/attributes-actions.component';
import { FilterFromAttributeComponent } from 'src/app/components/dialog/attributes/filter-from-attribute/filter-from-attribute.component';
import { ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE, ATTRS_VALUE_TYPES_TRANSLATE } from 'src/app/constants/preset-element-actions';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { AttributeList } from 'src/app/models/attribute.model';
import { DialogModalService, LanguageService, NotificationService } from 'src/app/services';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';

export type SortDirection = 'asc' | 'desc' | '';

@Component({
  selector: 'app-attributes-list',
  templateUrl: './attributes-list.component.html',
  styleUrls: ['./attributes-list.component.css']
})
export class AttributesListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  attributes: AttributeList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: any; //ListParams
  selectedAttributeId: any;
  filterParams: any = null;
  firstState: any = null;
  countSelectedFiles: number = 0;
  attribute_type:boolean;
  checkArr: boolean[] = [];
  action: boolean = false;

  headerDirection: any[] = [];
  sort: any = {};
  direction: SortDirection = 'asc';

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private dialogModal: DialogModalService,
    private apiAttributesService: ApiAttributesService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.attributes = [];

    this.setListParams();

    this.apiAttributesService.getAttributList(this.listParams).subscribe((response: Res) => {
      console.log("RESPONSE_LIST: ", response)

      if (response != null) {

        this.attributes = response.result.attributes;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }

        this.countSelectedFiles = 0
      } 
      this.countSelectedFiles = 0
      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.countSelectedFiles = 0
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    let data = this.filterParams ? this.filterParams : "";

    this.listParams = {
      lang_code: "rus",
      sort_by: this.sort.sortBy,
      direction: this.sort.direction,
      attr_name: data.attr_name ? data.attr_name : "",
      author: data.author != '' ? data.author : [],
      attr_group: data.attr_group != '' ? data.attr_group : [],
      type: data.type != '' ? data.type : [],
      mandatory: data.mandatory ? data.mandatory : "",
      type_attr: data.type_attr ? data.type_attr : "",
      scale: data.scale ? data.scale : "",
      format: data.format != '' ? data.format : [],
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }

    //при первом запросе сипска устанавливаем поле тип атрибутов на "коммерческий"
    if(!this.action){
      this.listParams['type_attr'] = 'commercial'
    }
  }


  /**
   * 
   * @param attr_id 
   */
  sortData(attr_id: string) {

    const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

    if(this.sort.sortBy == attr_id) {

      this.headerDirection[0].direction = rotate[this.headerDirection[0].direction];

      this.sort.direction = this.headerDirection[0].direction;

    } else {

      let directionObj = {
        direction: this.direction
      }

      this.headerDirection.push(directionObj);

      let sortObj = {
        sortBy: attr_id,
        direction: this.direction
      }

      this.sort = sortObj;

    }

    console.log("SORT: ", this.sort);
    this.getList();
  }


    /**
   * 
   * @param attr_id 
   * @returns 
   */
    checkDirection(attr_id) {

      return this.sort.sortBy == attr_id ? this.sort.direction : '';
  
    }
  
  
    /**
     * 
     */
      isEmptyObject(obj) {
  
      return (obj && (Object.keys(obj).length === 0));
  
    }
  


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /**
   * 
   */
  actionWithAttribute(id:string = null): void {

    let data = {
      attr_id: id
    }

    this.dialogModal.open(data, AttributesActionsComponent, 'xl').then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * вызов окна для фильтра
   */
  filterFromAttribute(): void {

    this.filterParams = this.filterParams ? this.firstState : this.filterParams;

    let data = {
      params: this.filterParams, 
      action: this.action
    }
    
    this.dialogModal.open(data, FilterFromAttributeComponent).then(

      (result) => {

        console.log(result);
        

        if (result) {

          this.firstState = result.value;
          this.action = result.action

          this.filterParams = result.check.length > 0 ? result.value : "";          
          this.getList();
        }

          
      },

      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   */
  resetFilterSettings() {

    this.filterParams = null;

    this.getList();
    
  }


  /**
   * удаление выбранных атрибутов
   */
  deleteSelected(): void {

    this.selectedAttributeId = [...new Set(this.attributes.filter(val => val.checked).map(({ id }) => id))];
    console.log(this.selectedAttributeId.length);
    

    let data = {
      ids: this.selectedAttributeId
    }

    this.dialogModal.open(data, AttributeDeletionConfirmationComponent).then(
      (result) => {

        if (result == true) {

          this.notification.show('success', 'Данные успешно удалены!');
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * удаление одного атрибута
   * @param id 
   */
  deleteOneAttr(id): void {
  
    let data = {
      ids: [id]
    }

    this.dialogModal.open(data, AttributeDeletionConfirmationComponent).then(
      (result) => {

        if (result) {

          this.notification.show('success', 'Данные успешно удалены!');
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   *
   */
  onEdit(id) {

    let dat = {
      attr_id: id
    }

    this.dialogModal.open(dat, AttributesActionsComponent, 'xl').then(
      (result) => {
        
        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   */
  obligation(params: string): void {

    this.selectedAttributeId = [...new Set(this.attributes.filter(val => val.checked).map(({ id }) => id))];

    let data = {
      attr_id: this.selectedAttributeId,
      mandatory: params
    }

    this.subscriptions.add(
      this.apiAttributesService.attributeMandatory(data).subscribe((response: any) => {

        if (response != null) {

          this.countSelectedFiles = 0
          this.getList();
          this.notification.show('success', 'Данные успешно обновлены!');
        }
      })
    );
  }


  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
   selectedCheckBox(index: number, event: any): void {

    this.attributes[index].checked = event.target.checked;
    this.counterSelectedFiles();

    this.counterSelectedFiles();

    this.checkAccess(this.attributes[index].commercial, event.target.checked, index);
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.attributes.forEach(x => x.checked = event.target.checked);

    this.counterSelectedFiles()
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.attributes.length == 0) return false;

    return this.attributes.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.attributes.length;
    let pc = this.attributes.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {
    
    let pc = this.attributes.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }


  /**
   * 
   * @param event 
   */
  toggleChecked(attr_id: number, event): void {

    let data = {
      attr_id: [attr_id],
      mandatory: event.target.checked
    }

    this.subscriptions.add(
      this.apiAttributesService.attributeMandatory(data).subscribe((response: any) => {

        if (response != null) {

          this.countSelectedFiles = 0
          this.getList();
          this.notification.show('success', 'Данные успешно обновлены!');
        }
      })
    );

    console.log("EVENT:", event.target.checked);
  }


  /**
   * 
   */
  counterSelectedFiles() {

    this.countSelectedFiles = this.attributes.filter(val => val.checked).length;

  }

  checkAccess(attr_type: boolean, event, index){

  console.log("ATTR TYPE: ", this.checkArr);

   event ? this.checkArr.push(attr_type) : this.checkArr.splice(index, 1);

   this.checkArr.forEach(el => {

    if(!el) {

      this.attribute_type = false;
      
      return;

    } else {

      this.attribute_type = true;

    }

   })
    
  }


  /**
   * 
   * @param id 
   * @returns 
   */
  getAttrType(id: string): string {

    let type: any = ATTRS_VALUE_TYPES_TRANSLATE.find(val => val.id == id);
    return type.translate;

  }


  /**
   * 
   * @param id 
   * @returns 
   */
  getAttrFormat(id: string): string {

    let type: any = ATTRS_VALUE_PRESENTATION_TYPES_TRANSLATE.find(val => val.id == id);
    return type.translate;
  }
}
